import React from "react"
import PropTypes from "prop-types"
import MuiDialog from "@material-ui/core/Dialog"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import Grow from "@material-ui/core/Grow"

import textStyleSheet from "ui-Text/styles"
import classnames from "classnames"

const styleSheet = theme => {
  const textStyles = textStyleSheet(theme)

  return {
    root: {
      ...textStyles.base,
    },
  }
}

export function StyledDialog({
  children,
  classes,
  className: classNameProp,
  transition,
  ...otherProps
}) {
  const className = classnames(classes.root, classNameProp)

  return (
    <MuiDialog {...otherProps} className={className} TransitionComponent={transition || Grow}>
      {children}
    </MuiDialog>
  )
}

StyledDialog.propTypes = {
  transition: PropTypes.func,
}

import withStyles from "@material-ui/core/styles/withStyles"
const Dialog = withStyles(styleSheet)(StyledDialog)
export default Dialog

export const ResponsiveDialog = withMobileDialog({ breakpoint: "xs" })(Dialog)
export const LargeResponsiveDialog = withMobileDialog({ breakpoint: "sm" })(Dialog)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/Dialog.js